/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`    
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
Wrapper.displayName = 'Wrapper';

export const ContainerData = styled.div` 
  background: ${({ showGradient, theme }) =>
        showGradient
            ? `linear-gradient(
                to bottom,
                ${theme.backgrounds.modal} 0%,       
                ${theme.backgrounds.modal} 33.33%,  
                ${theme.backgrounds.modal4} 33.33%,   
                ${theme.backgrounds.modal4} 66.66%,   
                ${theme.backgrounds.modal} 66.66%,  
                ${theme.backgrounds.modal} 100%
            )`
            : theme.backgrounds.modal};
  box-shadow: 0 2px 50px 0 ${({ theme }) => theme.textfield.background};
  overflow-y: auto;
  min-height: 110px;
  max-height: 110px;
  margin-top: 5px;
`;
ContainerData.displayName = 'ContainerData';

export const Item = styled.div`    
  cursor: pointer;
  padding: 0 14px;
  height: 36.6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.modal4 : props.theme.backgrounds.modal)};
  color: ${({ theme }) => theme.textfield.text};
  &:hover {
      background-color: ${({ theme }) => theme.selector.selected};
    }
`;
Item.displayName = 'item';

export const Label = styled.div`    
  font-size: 12.5px;
  background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.modal4 : props.theme.backgrounds.modal)};
  color: ${({ theme }) => theme.textfield.text};
`;
Label.displayName = 'Label';
